import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Helmet } from 'react-helmet';
import { RfpProOfferedView } from '@/components/pages/rfp/professional/RfpProOfferedView';
import Layout from '@/container/Layout';
/**
 * コンサルタント：案件提案提出後確認ページ全体を表示する
 */
export const RfpProOfferOfferedPage = (props) => {
    const { offer, rfp } = props;
    const title = `${rfp.name} 入力内容の確認`;
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main' }, { children: [_jsx(Helmet, { children: _jsx("title", { children: `${title}｜PROFFIT` }) }), _jsx(RfpProOfferedView, { budget: rfp.max_budget || rfp.budget, offer: offer, paymentOption: rfp.payment_option, rfpId: rfp.id, rfpName: rfp.name, rfpType: rfp.rfp_type, title: title })] })));
};
